import { Component, Input, ViewChild } from '@angular/core';
import { BaseModalComponent } from 'projects/libraries/syslink-components/src/lib/modal/base-modal/base-modal.component';
import { PurchaseCreditNoteHeaderStatus } from '../../purchase-credit-note-header-statuses/purchase-credit-note-header-status.model';
import { FilterDescriptor } from 'devextreme/data';
import { SelectComponent } from 'projects/libraries/syslink-components/src/public-api';
import { PurchaseCreditNoteHeaderStatusesService } from '../../purchase-credit-note-header-statuses/purchase-credit-note-header-statuses.service';

@Component({
  selector: 'app-purchase-credit-note-status-select-modal',
  templateUrl: './purchase-credit-note-status-select-modal.component.html',
  styleUrls: ['./purchase-credit-note-status-select-modal.component.scss']
})
export class PurchaseCreditNoteStatusSelectModalComponent extends BaseModalComponent<PurchaseCreditNoteHeaderStatus>{
  @Input() public selectFilters: FilterDescriptor | Array<FilterDescriptor>;
  @Input() public expand: FilterDescriptor | Array<FilterDescriptor>;
  @Input() public title: string = "Select credit-note status";
  @Input() public content?: string;
  @Input() public data: any;
  @ViewChild('select') select?: SelectComponent;

  constructor(public purchaseCreditNoteHeaderStatusesService: PurchaseCreditNoteHeaderStatusesService) {
    super();
  }

}